function init_track_page(form) {

    let track = new TrackPage();
    track.initRequestLink(form);
    track.initTrackSlider();
}